import { formatDate } from '@angular/common';
import { Language } from '@src/core';

/**
 * Утилита, которая преобразует дату в строку API формата.
 *
 * @param date дата
 * @param timezone в формате '+0300'
 */
export const convertDateToApiFormat = (
  date?: Date | null,
  useTimeZone: boolean = true,
  timezone?: string,
): string | undefined => {
  const format = useTimeZone ? 'yyyy-MM-ddTHH:mm:ss.SSSZ' : 'yyyy-MM-ddTHH:mm:ss';
  return date ? formatDate(date, format, Language.EN, timezone) : undefined;
};

/**
 * Утилита, которая преобразует дату в строку API формата c указанной временной зоной.
 *
 * @param date дата
 * @param timezone в формате '+0300'
 */
export const convertDateToApiFormatWithNewTimezone = (
  date: Date | null | undefined,
  timezone: string,
): string | undefined => {
  const format = 'yyyy-MM-ddTHH:mm:ss.SSS';
  return date ? formatDate(date, format, Language.EN) + timezone : undefined;
};

/**
 * Утилита, которая возвращает Timezone в формате '+0300'.
 *
 * @param date дата
 */
export const getTimezone = (date?: Date | null): string | undefined => {
  return date ? formatDate(date, 'Z', Language.EN) : undefined;
};

/**
 * Утилита, которая возвращает дату в нужной Timezone.
 *
 * @param date дата
 * @param timezone в формате '+0300'
 */
export const setTimezone = (date: Date | null | undefined, timezone: string): string | undefined => {
  const format = 'yyyy-MM-ddTHH:mm:ss';
  return date ? formatDate(date, format, Language.EN, timezone) : undefined;
};
